module.exports = __webpack_public_path__ + "static/media/decor4.5f622181.jpg";